import React, { useEffect, useRef, useState } from 'react'
import { styled } from "@mui/material/styles";
import { Container, Box, Paper, Typography, Table, TableBody, TableCell, TableRow, Card, CardContent, Link, Divider, Grid, Button } from "@mui/material";
import { Form, Formik } from 'formik';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import CustomDropdownMui from '../../../../Components/CustomDropDown/CustomDropdown';
import CustomFromAndToDate from '../../../../Components/CustomFromAndToDate/CustomFromAndToDate';

import FileUploadComponent from '../../../../Components/FileUploadComponent/FileUploadComponent';
import { adminUrl } from '../../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import MultipleFileUploadComponent from '../../../../Components/FileUploadComponent/MultipleFileUploadComponent';
import { toast, ToastContainer } from 'react-toastify';
import * as Yup from "yup";
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';


const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));



const validationSchema = Yup.object().shape({
    campusName: Yup.string().required("Campus Name is required"),
    EventTitle: Yup.string().required("Event Title is required"),
    details: Yup.string().required("Details are required"),
    fromDate: Yup.date()
        .required("From Date is required")
        .typeError("From Date must be a valid date"),
    toDate: Yup.date()
        .required("To Date is required")
        .typeError("To Date must be a valid date")
        .min(
            Yup.ref("fromDate"),
            "To Date cannot be earlier than From Date"
        ),

});


const Events = ({ handleAddFormGoBackButton, editById, setEditById }) => {
    const [uploadedFile, setUploadedFile] = useState([]);
    console.log(uploadedFile, "uploadedfiles")
    const [uploadedFile2, setUploadedFile2] = useState(null);
    const formikRef = useRef();

    console.log(editById, "editbyidddddd")
    const dispatch = useDispatch()

    const { EventPost } = useSelector(
        (state) => state?.EventPost
    );
    const [loading, setLoading] = useState(false);


    console.log(EventPost, "EventPostEventPost")
    // const countries = [
    //     { value: "India", label: "India" },
    //     { value: "USA", label: "USA" },
    //     { value: "UK", label: "UK" },
    //     { value: "Australia", label: "Australia" },
    // ];

    const campusName = [
        { value: "Campus", label: "Campus" },

    ];

    useEffect(() => {


        if (editById) {

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getEventById/${editById}`,
                };
                const response = await dispatch(actions.EVENTGETBYID(data1));

                console.log(response, "responseresponse")
                const { setFieldValue } = formikRef.current;


                if (response?.payload?.message === "Event fetched successfully.") {
                    //     console.log("hiiii")

                    console.log(response, "responseresponse")

                    setFieldValue("campusName", response?.payload?.data?.campus_name)
                    setFieldValue("EventTitle", response?.payload?.data?.event_title)
                    setFieldValue("details", response?.payload?.data?.requirements)
                    setFieldValue("fromDate", response?.payload?.data?.from_date)
                    setFieldValue("toDate", response?.payload?.data?.to_date)




                    const uploadedFiles = response?.payload?.data?.attach_files
                    console.log(uploadedFiles, "uploadedFileuploadedFile")


                    // for (let i = 1; i <= 7; i++) {
                    //     const imageKey = `image${i}`;
                    //     const imgUrlKey = `img_url${i}`;

                    //     if (data?.[imageKey] && data?.[imgUrlKey]) {
                    //         uploadedFiles.push({
                    //             id: i,
                    //             fileUrl: data[imgUrlKey],
                    //             type: "img",
                    //             progress: 100,
                    //         });
                    //     }
                    // }

                    setUploadedFile(uploadedFiles);


                }
            };
            fetchData();
        }

    }, []);


    const sessionAdminId = sessionStorage.getItem("adminId")



    const handleSubmit = async (values, { resetForm }) => {


        const data1 = {
            data: {
                user_id: Number(sessionAdminId),
                campus_name: values?.campusName,
                event_title: values?.EventTitle,
                from_date: values?.fromDate,
                to_date: values?.toDate,
                attach_files: uploadedFile,
                requirements: values?.details
            },
            method: editById ? "put" : "post",
            apiName: editById ? `updateEvent/${editById}` : `createEvent`,
            isFormData: true,
        };

        const responseData = await dispatch(editById ? actions.UPDATEEVENT(data1) : actions.EVENTPOST(data1));
        if (responseData?.payload?.message === `Event ${editById ? "updated" : "created"} successfully.`) {
            setLoading(false)
            // toast.success(`Event ${editById ? "updated" : "created"} successfully`);
            toast.success(`Event ${editById ? "updated" : "created"} successfully`);


            setTimeout(() => {
                handleAddFormGoBackButton();
                resetForm();
                setEditById(null)
                setUploadedFile([]); // Clear uploaded files

                // toast.success(`Event ${editById ? "updated" : "created"} successfully`);
            }, 1500);


        } else {
            // setLoading(false)

            toast.error(`Event not ${editById ? "updated" : "created"}`);

        }
    };


    return (
        <Box>
            <Box data-aos="zoom-in" data-aos-duration="1000"
                sx={{
                    position: 'relative',
                }}
            >
                {loading && <FullPageLoader />}

                <Box>
                    <ProfileContainer p={{ xs: 0 }} mb={2} >
                        <Container maxWidth="lg" >
                            <ResponsiveBox mt={2}>
                                <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                                    <Typography variant="h6" gutterBottom>Events</Typography>
                                    <Divider />
                                    <Box>
                                        <Formik
                                            innerRef={formikRef}

                                            initialValues={{
                                                campusName: "",
                                                EventTitle: "",
                                                details: "",
                                                fromDate: "",
                                                toDate: "",
                                                file1: "",

                                            }}
                                            validationSchema={validationSchema}
                                            onSubmit={handleSubmit}
                                        >
                                            {({ isSubmitting, values, setFieldValue, resetForm, errors, touched, handleChange, handleBlur }) => (
                                                <Form>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 2,
                                                            mt: 2
                                                        }}
                                                    >


                                                        <Grid container spacing={2}>
                                                            <Grid item size={{ md: 4, xs: 12, sm: 6 }} >
                                                                <CustomInputLogin
                                                                    label="Campus Name"
                                                                    name="campusName"
                                                                    custPlaceholder="Enter Campus Name"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                                {/* <CustomDropdownMui
                                                                    label="Campus Name"
                                                                    name="campusName"
                                                                    options={campusName}
                                                                    custPlaceholder="Select Campus Name"
                                                                // image={country_icon}
                                                                // important={true}
                                                                /> */}
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Event Title"
                                                                    name="EventTitle"
                                                                    custPlaceholder="Enter Event Title"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                            </Grid>
                                                            {/* <Grid size={{md:4}}> */}
                                                            <CustomFromAndToDate label1="From Date" label2="To Date" />
                                                            {/* </Grid> */}

                                                            <Grid item size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <MultipleFileUploadComponent
                                                                    uploadedFiles={uploadedFile}
                                                                    setUploadedFiles={setUploadedFile}
                                                                    onFilesChange={(files) => {
                                                                        console.log("Uploaded files:", files);
                                                                    }}
                                                                />
                                                            </Grid>

                                                            {/* <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <FileUploadComponent
                                                                    name="file1"
                                                                    uploadedFile={uploadedFile}
                                                                    setUploadedFile={setUploadedFile}
                                                                    onFileUpload={(file) => setFieldValue("file1", file)}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <FileUploadComponent
                                                                    name="file2"
                                                                    uploadedFile={uploadedFile2}
                                                                    setUploadedFile={setUploadedFile2}
                                                                    onFileUpload={(file) => setFieldValue("file2", file)}
                                                                />
                                                            </Grid> */}
                                                            <Grid size={{ md: 12, xs: 12, sm: 12 }}>
                                                                <CustomInputLogin
                                                                    label="Details of Requirements"
                                                                    name="details"
                                                                    custPlaceholder="Message"
                                                                    inputType="textarea"
                                                                />
                                                            </Grid>

                                                            {/* <Grid size={{ md: 4, xs: 12, sm: 0 }}></Grid>
                                                        <Grid size={{ md: 4, xs: 12, sm: 6 }}></Grid> */}

                                                            <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                                                <Button
                                                                    onClick={() => {
                                                                        // resetForm()
                                                                        handleAddFormGoBackButton()
                                                                        setEditById()
                                                                    }}
                                                                    variant="contained"
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "black",
                                                                        fontSize: "16px",
                                                                        padding: { xs: "0px 20px", md: "0px 50px" },
                                                                        marginRight: "5px",
                                                                        boxShadow: 1,
                                                                        border: "1px solid #ced4da",
                                                                        minHeight: "40px",
                                                                        // borderRadius: "23px",
                                                                        background: "white 0% 0% no-repeat padding-box",
                                                                        "&:hover": {
                                                                            backgroundColor: "white",
                                                                        },
                                                                    }}
                                                                >
                                                                    Go back
                                                                </Button>
                                                                <Button
                                                                    type="submit"
                                                                    variant="contained"
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "white",
                                                                        fontSize: "16px",
                                                                        padding: { xs: "0px 20px", md: "0px 50px" },

                                                                        boxShadow: "none",
                                                                        minHeight: "40px",
                                                                        // borderRadius: "23px",
                                                                        background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                                        "&:hover": {
                                                                            backgroundColor: "var(--main-color)",
                                                                        },
                                                                    }}
                                                                >
                                                                    {editById ? "Update" : "Submit"}

                                                                </Button>
                                                            </Grid>

                                                        </Grid>




                                                    </Box>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Box>
                                </Paper>
                            </ResponsiveBox>
                        </Container>
                    </ProfileContainer>
                </Box>
            </Box>
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />

        </Box>
    )
}

export default Events